import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetCaseKey = 'get-case-by-guid';

export const useGetCase = (caseGuid?: string) => {
    const { zoneApiClient }= useZoneContext();
    return useQuery({
        queryKey: [useGetCaseKey, caseGuid],
        queryFn: async ({ queryKey }) => {
            const [, caseGuid] = queryKey;
            const response = await zoneApiClient.getCaseById(caseGuid ?? '');

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve this case.');
            }
            return response.payload;
        },
        enabled: !!caseGuid,
        staleTime: 0,
        cacheTime: 0,
    })};
